<template>
  <div class="property-index-container">
    <!-- 导航路径 -->
    <div class="vc-index-nav">
      <span
        ><i class="el-icon-s-home margin-right-sm"></i
        >{{ $t("propertyIndex.home") }}</span
      >
      <span class="margin-left-sm margin-right-sm">/</span>
      <span>{{ $t("propertyIndex.dashboard") }}</span>
    </div>

    <!-- 父组件数据加载中状态 -->
    <el-loading
      v-loading="!isParentDataReady"
      text="正在加载数据..."
      spinner="el-icon-loading"
      background="rgba(255, 255, 255, 0.8)"
      class="parent-loading"
    >
      <!-- 数据加载完成后才渲染子组件 -->
      <div v-if="isParentDataReady">
        <el-row class="vc-index-1" :gutter="20">
          <el-col :span="15">
            <!-- 传递 repairData 和 roomStateMap 给社区信息组件 -->
            <index-community
              :repairData="repairData"
              :roomStateMap="roomStateMap"
            />
          </el-col>
          <el-col :span="9">
            <index-notice />
          </el-col>
        </el-row>

        <el-row class="vc-index-1" :gutter="20">
          <el-col :span="15">
            <!-- 关键修改：补充传递 roomStateMap 给维修投诉组件 -->
            <index-repair-complaint
              :complaintData="complaintData"
              :roomStateMap="roomStateMap"
            />
          </el-col>
          <el-col :span="9">
            <index-owner-room />
          </el-col>
        </el-row>
      </div>
    </el-loading>
  </div>
</template>

<script>
import IndexCommunity from "@/components/index/indexCommunity";
import IndexNotice from "@/components/index/indexNotice";
import IndexRepairComplaint from "@/components/index/indexRepairComplaint";
import IndexOwnerRoom from "@/components/index/indexOwnerRoom";
import { getRepairIndex } from "@/api/index/propertyIndexApi";
import { getDict } from "@/api/community/communityApi";

export default {
  name: "PropertyIndex",
  components: {
    IndexCommunity,
    IndexNotice,
    IndexRepairComplaint,
    IndexOwnerRoom,
  },
  data() {
    return {
      repairData: null, // 维修投诉核心数据
      complaintData: null, // 维修投诉核心数据
      roomStateMap: {}, // 房间状态映射表
      // 备用状态映射（接口失败时使用）
      backupStateMap: {
        2001: "租赁中",
        2002: "未销售",
        2003: "已交房",
        2004: "未入住",
        2005: "已装修",
        2007: "已售",
        2008: "空置中",
        2009: "装修中",
        2010: "借用中",
        2011: "免租期",
      },
      isParentDataReady: false, // 父组件数据是否加载完成
    };
  },
  mounted() {
    console.log("父组件开始初始化");
    this.initData(); // 优先加载父组件数据
  },
  methods: {
    async initData() {
      try {
        // 1. 先加载房间状态字典
        await this.loadRoomStateMap();
        // 2. 再加载维修投诉统计数据
        await this.loadRepairIndexData();
        await this.loadComplaintDataData();
        // 3. 标记数据加载完成，渲染子组件
        this.isParentDataReady = true;
        console.log("父组件数据加载完成，开始渲染子组件");
      } catch (error) {
        console.error("父组件初始化失败:", error);
        // 即使失败也显示子组件，避免页面空白
        this.isParentDataReady = true;
      }
    },

    // 加载房间状态字典
    async loadRoomStateMap() {
      console.log("开始加载房间状态字典");
      try {
        const response = await getDict("building_room", "state");
        console.log("状态字典接口返回:", response);

        // 兼容接口返回格式（可能是直接数组或包含data字段的对象）
        const dictData = Array.isArray(response) ? response : response || [];

        if (Array.isArray(dictData)) {
          const newStateMap = {};
          dictData.forEach((item) => {
            // 确保 statusCd 和 name 字段存在
            if (item.statusCd && item.name) {
              newStateMap[item.statusCd] = item.name;
            }
          });
          // 若解析结果为空，使用备用映射
          this.roomStateMap = Object.keys(newStateMap).length
            ? newStateMap
            : this.backupStateMap;
        } else {
          throw new Error("字典数据格式异常，使用备用映射");
        }
        console.log("最终状态映射表:", this.roomStateMap);
      } catch (error) {
        console.error("加载状态字典失败:", error);
        this.roomStateMap = this.backupStateMap;
      }
    },

    // 加载维修投诉统计数据
    async loadRepairIndexData() {
      console.log("开始加载维修投诉数据");
      const param = {
        page: 1,
        row: 300,
        communityId: this.getCommunityId(),
      };
      console.log("请求参数:", param);

      try {
        const res = await getRepairIndex(param);
        console.log("维修数据接口返回:", res);
        this.repairData = res.data || null;
      } catch (error) {
        console.error("加载维修数据失败:", error);
        this.repairData = null;
      }
    },
    // 加载维修投诉统计数据
    async loadComplaintDataData() {
      console.log("开始加载维修投诉数据");
      const param = {
        page: 1,
        row: 300,
        communityId: this.getCommunityId(),
      };
      console.log("请求参数:", param);

      try {
        const res = await getRepairIndex(param);
        console.log("维修数据接口返回:", res);
        this.complaintData = res.data || null;
      } catch (error) {
        console.error("加载维修数据失败:", error);
        this.complaintData = null;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.property-index-container {
  padding: 0 10px;

  .vc-index-nav {
    padding: 10px;
    font-size: 16px;
    text-align: left;
    color: #666;
  }

  .parent-loading {
    margin: 15px 0;
    min-height: 600px; // 确保加载状态有足够高度
  }

  .vc-index-1 {
    margin-bottom: 20px;
  }

  .margin-right-sm {
    margin-right: 5px;
  }

  .margin-left-sm {
    margin-left: 5px;
  }
}
</style>
